/**
 * hot_spot click animations.
 *
 * @package globus
 * @since   1.0.0
 */
import $ from 'jquery';

/**
 * Kick-off hover animations.
 *
 * @since 1.0.0
 */

function checkSpotPosition(spotId) {
	const el = $(spotId);
	const parent = $(spotId).parent();
	const wrap = $('.hot_spot__container');
	const rightEdge = el.width() + el.offset().left;
	const parentRightEdge = parent.width() + parent.offset().left;
	const parentLeftEdge = parent.offset().left;
	const wrapRightEdge = wrap.width() + wrap.offset().left;
	const wrapLeftEdge = wrap.offset().left;
	const leftEdge = el.offset().left;
	const wrapWidth = wrap.width();
	const rightValue = (parentRightEdge - wrapRightEdge) + 10;
	const leftValue = (parentLeftEdge - wrapLeftEdge) - 10;

	if ((rightEdge > wrapWidth) && (leftEdge <= 0)) {
		$(spotId).addClass('offscreen__right');
		$(spotId).addClass('offscreen__left');
		$(spotId).css('right', `${rightValue}px`);
		$(spotId).css('left', ` - ${leftValue}px`);
	} else if (rightEdge > wrapWidth) {
		$(spotId).addClass('offscreen__right');
		$(spotId).css('right', `${rightValue}px`);
		$(spotId).css('left', 'auto');
		$(spotId).css('transform', 'none');
	} else if (leftEdge <= 0) {
		$(spotId).addClass('offscreen__left');
		$(spotId).css('left', ` - ${leftValue}px`);
		$(spotId).css('right', 'auto');
		$(spotId).css('transform', 'none');
	} else {
		$('.hot_spot__card').removeClass('offscreen__right');
		$('.hot_spot__card').removeClass('offscreen__left');
	}
}

function initHotSpot() {
	const cards = document.getElementsByClassName('hot_spot__card');
	let i;
	for (i = 0; i < cards.length; i++) {
		const spotId = `#${cards[i].getAttribute('id')}`;
		checkSpotPosition(spotId);
	}
}

$('.hot_spot__close').click(
	() => {
		$('.hot_spot__card').removeClass('active');
		$('.hot_spot__card').removeClass('offscreen__right');
		$('.hot_spot__card').removeClass('offscreen__left');
		$('.hot_spot__point').removeClass('active');
	},
);

$(document).on(
	'click touchstart',
	(e) => {
		const container = $('.hot_spot__card.active');
		if (e.target.classList.contains('hot_spot__point')) {
			const spotId = e.target.getAttribute('data-card');

			$('.hot_spot__card').removeClass('active');
			$('.hot_spot__point').removeClass('active');
			$('.hot_spot__card').removeClass('offscreen');
			$(e.target).addClass('active');
			$(spotId).addClass('active');
			checkSpotPosition(spotId);
		} else if (!container.is(e.target) && container.has(e.target).length === 0 && !e.target.classList.contains('fa-close')) {
			container.removeClass('active');
		}
	},
);
window.addEventListener('resize', initHotSpot);
document.addEventListener('DOMContentLoaded', initHotSpot);
